import { Exception } from '../../core/models';

const ActionTypes = {
  LOAD_EXCEPTIONS: `[EXCEPTION] Load EXCEPTION`,
  LOAD_EXCEPTIONS_SUCCESS: `[EXCEPTION] Load EXCEPTION Success`,
  LOAD_EXCEPTIONS_FAIL: `[EXCEPTION] Load EXCEPTION Fail`,

  SAVE_EXCEPTION: `[EXCEPTION] Save EXCEPTION`,
  SAVE_EXCEPTION_SUCCESS: `[EXCEPTION] Save EXCEPTION Success`,
  SAVE_EXCEPTION_FAIL: `[EXCEPTION] Save EXCEPTION Fail`,

  DELETE_EXCEPTION: `[EXCEPTION] Delete EXCEPTION`,
  DELETE_EXCEPTION_SUCCESS: `[EXCEPTION] Delete EXCEPTION Success`,
  DELETE_EXCEPTION_FAIL: `[EXCEPTION] Delete EXCEPTION Fail`,
};

export class LoadExceptionsAction {
  static type = ActionTypes.LOAD_EXCEPTIONS;

  constructor(public payload?: any) {
  }
}
export class LoadExceptionsSuccessAction {
  static type = ActionTypes.LOAD_EXCEPTIONS_SUCCESS;

  constructor(public payload: Exception<any>[]) {
  }
}
export class LoadExceptionsFailAction {
  static type = ActionTypes.LOAD_EXCEPTIONS_FAIL;

  constructor(public payload: any) {
  }
}




export class SaveExceptionAction {
  static type = ActionTypes.SAVE_EXCEPTION;

  constructor(public payload: Exception<any>) {
  }
}
export class SaveExceptionSuccessAction {
  static type = ActionTypes.SAVE_EXCEPTION_SUCCESS;

  constructor(public payload: Exception<any>) {
  }
}
export class SaveExceptionFailAction {
  static type = ActionTypes.SAVE_EXCEPTION_FAIL;

  constructor(public payload: any) {
  }
}




export class DeleteExceptionAction {
  static type = ActionTypes.DELETE_EXCEPTION;

  constructor(public payload: number) {
  }
}
export class DeleteExceptionSuccessAction {
  static type = ActionTypes.DELETE_EXCEPTION_SUCCESS;

  constructor(public payload: number) {
  }
}
export class DeleteExceptionFailAction {
  static type = ActionTypes.DELETE_EXCEPTION_FAIL;

  constructor(public payload: any) {
  }
}
